import config from "../config/config.js";
import { getHeaders, handleResponse } from "./utils";

const SystemAdminService = {
  async getCompanies() {
    const headers = getHeaders();
    const response = await fetch(config.serviceHost + "admin/companies", {
      method: "GET",
      headers
    });
    return handleResponse(response);
  },

  async getCompany(companyId) {
    const headers = getHeaders();
    const response = await fetch(
      config.serviceHost + `admin/company/${companyId}`,
      {
        method: "GET",
        headers
      }
    );
    return handleResponse(response);
  },

  async postCompany(companyId, companyProfile, seatLimit, subscriptionStatus) {
    const headers = getHeaders();
    const data = new FormData();
    data.append("companyProfile", JSON.stringify(companyProfile));
    data.append("seatLimit", seatLimit);
    data.append("subscriptionStatus", subscriptionStatus);
    const response = await fetch(
      config.serviceHost + `admin/company/${companyId}`,
      {
        method: "POST",
        body: data,
        headers
      }
    );
    return handleResponse(response);
  },

  async postNewCompany(
    companyProfile,
    adminEmail,
    password,
    adminFirstName,
    adminLastName,
    accountProfile,
    loanOfficerRole
  ) {
    const headers = getHeaders();
    const data = new FormData();
    data.append("companyProfile", JSON.stringify(companyProfile));
    data.append("adminEmail", adminEmail);
    data.append("password", password);
    data.append("adminFirstName", adminFirstName);
    data.append("adminLastName", adminLastName);
    data.append("accountProfile", JSON.stringify(accountProfile));
    data.append("loanOfficerRole", loanOfficerRole);
    const response = await fetch(config.serviceHost + `admin/company`, {
      method: "POST",
      body: data,
      headers
    });
    return handleResponse(response);
  },

  async postAddMultipleUsers(companyId, csvFile) {
    const headers = getHeaders();
    const data = new FormData();
    data.append("csvFile", csvFile);
    const response = await fetch(
      config.serviceHost + `admin/add-multiple-users/${companyId}`,
      {
        method: "POST",
        body: data,
        headers
      }
    );
    return handleResponse(response);
  },

  // Regenerate demo dashboard data for a company: fresh loansummary rows (VIEW +
  // VISION, weighted toward the present so every timeframe tab is populated) and
  // lost-scenario rows. Re-runnable; replaces the company's existing demo rows.
  async seedDemoData(companyId) {
    const headers = getHeaders();
    const loans = await handleResponse(
      await fetch(config.serviceHost + `admin/seed-loans/${companyId}`, {
        method: "POST",
        headers
      })
    );
    const lost = await handleResponse(
      await fetch(config.serviceHost + `admin/seed-lost/${companyId}`, {
        method: "POST",
        headers
      })
    );
    return { loans, lost };
  },

  // Archive: subscription off + hidden from the default list; all users and loan
  // files are kept and Restore puts the previous subscription status back.
  async archiveCompany(companyId) {
    const response = await fetch(
      config.serviceHost + `admin/archive-company/${companyId}`,
      { method: "POST", headers: getHeaders() }
    );
    return handleResponse(response);
  },

  async restoreCompany(companyId) {
    const response = await fetch(
      config.serviceHost + `admin/restore-company/${companyId}`,
      { method: "POST", headers: getHeaders() }
    );
    return handleResponse(response);
  },

  // PERMANENT: cancels the Stripe subscription and deletes every user and loan
  // file in the company. The backend requires confirm=DELETE.
  async deleteCompany(companyId) {
    const data = new FormData();
    data.append("confirm", "DELETE");
    const response = await fetch(
      config.serviceHost + `admin/delete-company/${companyId}`,
      { method: "POST", body: data, headers: getHeaders() }
    );
    return handleResponse(response);
  }
};

export default SystemAdminService;
